import { container, singleton } from "tsyringe";

import { Config } from "../config";
import { WebRTCsdkService } from './webrtcsdk-service';


export const enum SoundKey {
  GoLive             = "GoLive",
  EndStream          = "EndStream",
  Error              = "Error",
  SwitchOnPresenter  = "SwitchOnPresenter",
  GuestBackstage     = "GuestBackstage",
  Record             = "Record",
  Popup              = "Popup",
  Trash              = "Trash",
  ToggleStageView    = "ToggleStageView",
  Exit               = "Exit",
}

@singleton()
export class SoundService {

  private webRTCsdkService = container.resolve(WebRTCsdkService);

  private testAudio = new Audio(process.env.PUBLIC_URL + '/sound/Studio_SpeakerTest.wav');

  // keep public : used in SettingsGeneral
  public sounds = [];
  public globalPlaySound = false;

  constructor() {
      // get sounds checked state from localStorage
      let soundsState = [];
      try {
        soundsState = JSON.parse(localStorage.getItem('soundsState') || JSON.stringify({GoLive: true, EndStream: true, Error: true, SwitchOnPresenter: true, GuestBackstage: true, Record: true, Popup: true, Trash: true, ToggleStageView: true, Exit: true,
        }));
      } catch (e) {}

      this.sounds = [
      { key: SoundKey.GoLive, checked: true, label: 'Going live', audio: new Audio(process.env.PUBLIC_URL + '/sound/Studio_GoLive.wav')},
      { key: SoundKey.EndStream, checked: true, label: 'Ending the livestream', audio: new Audio(process.env.PUBLIC_URL + '/sound/Studio_EndStream.wav') },
      { key: SoundKey.Error, checked: true, label: 'Getting an error message', audio: new Audio(process.env.PUBLIC_URL + '/sound/Studio_Error.wav')},
      { key: SoundKey.SwitchOnPresenter, checked: true, label: 'Guest presenters enter backstage', audio: new Audio(process.env.PUBLIC_URL + '/sound/Studio_SwitchOnPresenter.wav')},
      { key: SoundKey.GuestBackstage, checked: true, label: 'Adding guests to your livestream', audio: new Audio(process.env.PUBLIC_URL + '/sound/Studio_GuestBackstage.wav')},
      { key: SoundKey.Record, checked: true, label: 'Enabling record', audio: new Audio(process.env.PUBLIC_URL + '/sound/Studio_Record.mp3')},   // <!> mp3 here
      { key: SoundKey.Popup, checked: true, label: 'A notification pops up', audio: new Audio(process.env.PUBLIC_URL + '/sound/Studio_Popup.wav')},
      { key: SoundKey.Trash, checked: true, label: 'Deleting a preset', audio: new Audio(process.env.PUBLIC_URL + '/sound/Studio_Trash.wav')},
      { key: SoundKey.ToggleStageView, checked: true, label: 'Toggling stage view', audio: new Audio(process.env.PUBLIC_URL + '/sound/Studio_ToggleStageView.wav')},
      { key: SoundKey.Exit, checked: true, label: 'Exiting Studio', audio: new Audio(process.env.PUBLIC_URL + '/sound/Studio_Exit.wav')},
      ]

      for(const s of this.sounds) {
        s.checked = (soundsState[s.key] == 'false' || !soundsState[s.key] ) ? false : true
      }

      try {
        this.globalPlaySound = parseInt(localStorage.getItem('soundPlayGlobal') || '1') === 1;
      } catch(e){
        console.log(e)
        this.globalPlaySound = true;
      }

  }

  public testAudioStop = () => {
    if (this.testAudio) {
      this.testAudio.pause();
    }
  }

  public testAudioStart = (selectedSpeaker) => {
    if (this.testAudio) {
      try {
        (this.testAudio as any).setSinkId(this.webRTCsdkService.transformSpeakerId(selectedSpeaker.id, false));
      } catch (e) { }
      this.testAudio.pause();
      this.testAudio.currentTime = 0;
      this.testAudio.play();
    }
  }

  public setGlobalPlaySound(state) {
    this.globalPlaySound = state;
    localStorage.setItem('soundPlayGlobal', this.globalPlaySound ? '1' : '0');
  }

  public toggleSound(key) {
    const sound = this.sounds.find(s => s.key === key)
    if (sound) {
      sound.checked = !sound.checked
      const soundsState = {}
      for (const s of this.sounds) {
        soundsState[s.key] = s.checked
      }
      localStorage.setItem('soundsState', JSON.stringify(soundsState))
      if (sound.checked) {
        this.playSoundStart(key, true);
      }
    }
    return this.sounds
  }

  public playSoundStop(key) {
    const sound = this.sounds.find(s => s.key === key);
    if (sound) {
      sound.audio.pause();
    }
  }

  public playSoundStart(key, force = false) {

    // check for sound global activation
    if (this.globalPlaySound || force) {

      const sound = this.sounds.find(s => s.key === key);
      if (sound && sound.checked) {
        const selectedSpeaker = this.webRTCsdkService.selectedSpeaker$.getValue();
        try {
          (sound.audio as any).setSinkId(this.webRTCsdkService.transformSpeakerId(selectedSpeaker.id, false));
        } catch (e) { }
        sound.audio.pause();
        sound.audio.currentTime = 0;
        sound.audio.play();
      }
    }
  }


}
